import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';
import { Typography, Box } from '@material-ui/core';
import PageContent from '../../../components/PageStructure/PageContent/PageContent';
import PageHeader from '../../../components/PageStructure/PageHeader/PageHeader';
import PatientDetailsTabs from '../../../components/Patients/Patient/PatientDetailsTabs';
import Spinner from '../../../components/common/Spinner/Spinner';
import NonBlockingLoader from '.././../common/Loading/NonBlockingLoader';
import globals from '../../../globals/communityGlobals';
import { formatNhs } from '../../../utils/helpers';
import { ENABLE_SETTING_PATIENTS_AS_INACTIVE } from '../../../settings/constants/appSettings';

const locale = globals.getArea('patients');

class Patient extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: null,
    };
  }
  componentDidMount() {
    const { match, getPatient, getAppSettings, enableSettingPatientsAsInactive } = this.props;
    getPatient(match.params.patientId);
    if (enableSettingPatientsAsInactive == null) {
      getAppSettings(ENABLE_SETTING_PATIENTS_AS_INACTIVE);
    }
  }

  componentDidUpdate() {
    if (this.props.enableIntegrationMode && this.props.toggleReload && !this.props.syncFailed) {
      this.props.getPatient(this.props.match.params.patientId);
    }
  }

  getIsPatientActiveStatus = patient => {
    return this.state.isActive === null ? patient.isActive : this.state.isActive;
  };

  updatePatientIsActiveStatus = isActive => {
    this.setState({ isActive });
  };

  showPatientDetails = patient => {
    return (
      <div>
        <span>
          {`${patient.forename} ${patient.surname} - ${locale.getMsg('nhsNumber')}: ${formatNhs(patient.nhsNumber)}`}
        </span>
        {patient && patient.importedByExternalProvider ? <span>&nbsp;(imported)</span> : ''}
        {patient && this.props.enableSettingPatientsAsInactive === 'true' && !this.getIsPatientActiveStatus(patient) ? (
          <span style={{ color: 'red', fontStyle: 'italic' }}>&nbsp;-&nbsp;Inactive</span>
        ) : (
          ''
        )}
      </div>
    );
  };

  handleCloseSnackBar = () => {
    this.props.resetPatientSync();
  };

  render() {
    const {
      patient,
      message,
      isSnackBarOpen,
      syncFailed,
      isFetching,
      go,
      pageTitle,
      canEditPatients,
      canEditReferrals,
      canAddReferrals,
      canAddTreatments,
      canEditTreatments,
      enableIntegrationMode,
      syncPatient,
    } = this.props;

    const formattedErrorMsg = () => {
      return message.split(';').map(item => <p>{item}</p>);
    };

    return (
      <PageContent pageTitle={pageTitle}>
        <div className="content-wrapper">
          <PageHeader>
            <section className="title-section">
              <Box display="flex" alignItems="center" px={2} py={1}>
                <Box flexGrow={1}>
                  <Typography variant="h3">{locale.getMsg('patientDetails')}</Typography>
                  {/* <div>
                    {patient ? (
                      `${patient.forename} ${patient.surname} -
                        ${locale.getMsg('nhsNumber')}: ${formatNhs(patient.nhsNumber)}`
                    ) : (
                      <Spinner />
                    )}
                  </div> */}
                  <div>{patient ? this.showPatientDetails(patient) : <Spinner />}</div>
                </Box>
                <Box>
                  {patient ? (
                    <div>
                      {canAddReferrals === true && !enableIntegrationMode ? (
                        <RaisedButton
                          primary
                          style={{ margin: '4px' }}
                          onClick={() => go(`/Patients/${patient.id}/Referrals/Create`)}
                          label={locale.getMsg('createReferral')}
                        />
                      ) : (
                        ''
                      )}
                      {canEditReferrals === true ||
                      canAddReferrals === true ||
                      canAddTreatments === true ||
                      canEditTreatments === true ? (
                        <RaisedButton
                          primary
                          style={{ margin: '4px' }}
                          onClick={() => go(`/Patients/${patient.id}/Referrals`)}
                          label={locale.getMsg('viewReferrals')}
                        />
                      ) : (
                        ''
                      )}

                      {enableIntegrationMode ? (
                        <RaisedButton
                          primary
                          onClick={() => syncPatient(patient.id)}
                          label="Sync Patient"
                          disabled={isFetching}
                        />
                      ) : (
                        ''
                      )}
                    </div>
                  ) : (
                    <Spinner />
                  )}
                </Box>
              </Box>
            </section>
          </PageHeader>

          <Box display="flex" p={2}>
            <Box flexGrow={1}>
              {patient && !isFetching && !syncFailed ? (
                <PatientDetailsTabs
                  patient={patient}
                  canEditPatients={canEditPatients}
                  updatePatientIsActiveStatus={this.updatePatientIsActiveStatus}
                />
              ) : (
                <Spinner />
              )}
            </Box>
          </Box>
        </div>
        {syncFailed && (
          <NonBlockingLoader
            open={isSnackBarOpen}
            message={formattedErrorMsg(message)}
            autohideDuration={5000}
            closeSnackbar={() => this.handleCloseSnackBar()}
          />
        )}
      </PageContent>
    );
  }
}

Patient.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  patient: PropTypes.shape({
    address: PropTypes.shape({
      latitude: PropTypes.number,
      longitude: PropTypes.number,
      postCode: PropTypes.string,
    }),
    patientFullName: PropTypes.string,
  }),
  isFetching: PropTypes.bool.isRequired,
  getPatient: PropTypes.func.isRequired,
  go: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientId: PropTypes.string.isRequired,
    }),
  }).isRequired,
  canEditPatients: PropTypes.bool.isRequired,
  canEditReferrals: PropTypes.bool.isRequired,
  canAddReferrals: PropTypes.bool.isRequired,
  canAddTreatments: PropTypes.bool.isRequired,
  canEditTreatments: PropTypes.bool.isRequired,
  enableIntegrationMode: PropTypes.bool.isRequired,
  syncPatient: PropTypes.func,
};

Patient.defaultProps = {
  patient: null,
  syncPatient: () => {},
};

export default Patient;
